/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Close_ButtonInputs */

const en_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_embed_captions_close_button = /** @type {(inputs: Embed_Captions_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Embed_Captions_Close_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_close_button = /** @type {((inputs?: Embed_Captions_Close_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Close_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_close_button(inputs)
	if (locale === "de") return de_embed_captions_close_button(inputs)
	if (locale === "it") return it_embed_captions_close_button(inputs)
	if (locale === "ru") return ru_embed_captions_close_button(inputs)
	if (locale === "es") return es_embed_captions_close_button(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_close_button(inputs)
	if (locale === "ja") return ja_embed_captions_close_button(inputs)
	if (locale === "hi") return hi_embed_captions_close_button(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_close_button(inputs)
	return en_embed_captions_close_button(inputs)
});